import { render } from "./ModuleActivity.vue?vue&type=template&id=16288aff&scoped=true&ts=true"
import script from "./ModuleActivity.vue?vue&type=script&lang=ts"
export * from "./ModuleActivity.vue?vue&type=script&lang=ts"

import "./ModuleActivity.vue?vue&type=style&index=0&id=16288aff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16288aff"]])

export default __exports__